// virtual table


// import react and some other libs
import {
  React, ReactDOM,

  Ajax, AppBase, DataStore, Moment
} from 'app/react/Boot.jsx';

//var _ = require('lodash');

import ConsoleBase from './ConsoleBase.jsx';
import ConsoleWidget from 'app/react/excento/ExcentoCon.jsx';

console.log('ConsoleBase: ', ConsoleBase, ConsoleWidget)

// we can load custom css
const krynica = require('app/styles/krynica.css');

console.log('krynica css: ', krynica)


var APP_TYPE = "excento";


function reactParseUrlQueryParams(query) {
  var tmp = query.substring(1).split('=');
  var key, val, result = {}, tmp2, tmp3;

  for (var i = 0; i < tmp.length; i+=2) {
    if (tmp[i] == 'q') {
      result = {};
      tmp2 = tmp[i+1].split(',');

      for (var j = 0; j < tmp2.length; j++) {
        tmp3 = tmp2[j].split(':');

        key = tmp3[0];
        val = tmp3[1];

        result[key] = val;
      }
      break;
    }
  }

  return result;
}

var reactHashParams;

function waitForContent () {
  var target = document.getElementById('react-content')

  // we wait for target dom element and jquery library
  if (target) {

    // ReactDOM.render(<div style={{width: '100%', height: 500, background: 'black'}}><VirtTable /></div>, target)
    // var reactParamsDiv = document.getElementById('react-params');

    // we could use this object to pass some configuration
    var reactParams = {
    }



    global.__App = new ConsoleBase(ConsoleWidget, APP_TYPE,
      reactParams
    )

    __App.init(target);
  } else {

    if (!reactHashParams) {
      reactHashParams = reactParseUrlQueryParams(window.location.search);
    }

//    if (reactHashParams.hasOwnProperty('demo') && reactHashParams["demo"] == 1) {
      document.write("<div id='react-content'></div>");
//    }

    setTimeout(waitForContent, 100);
  }
}



waitForContent();



// WEBPACK FOOTER //
// ./app/excento.ent.jsx